import { EYEBROW } from './styles';
import Reveal from './Reveal';

export default function SectionHead({ eyebrow, lines = [], lead = null, className = '', as: Tag = 'h2' }) {
  return (
    <Reveal className={`max-w-3xl ${className}`}>
      {eyebrow && <p className={`${EYEBROW} mb-4`}>{eyebrow}</p>}
      {lines.length > 0 && (
        <Tag className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {lines.map((line, i) => (
            <span key={i} className="block">
              {line}
            </span>
          ))}
        </Tag>
      )}
      {lead && <p className="mt-6 max-w-2xl text-base leading-relaxed text-dim sm:text-lg">{lead}</p>}
    </Reveal>
  );
}
